// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"507":"privacyAgreement","673":"drink-menu","676":"drink-confirm","890":"userAgreement"}[chunkId] + "." + {"507":"236242a2","673":"b5b4218f","676":"b914049a","890":"96a335d5"}[chunkId] + ".css";
};